import { createRoutine } from 'redux-saga-routines';
import type CompanyAPIStatements from '@simplywallst/services/lib/endpoints/types/company/general/CompanyAPIStatements';

export interface FetchCompanyRisksTriggerPayload {
  companyId: string;
}

export interface FetchCompanyRisksSuccessPayload {
  companyId: string;
  statements: CompanyAPIStatements;
}

export interface FetchCompanyRisksFailurePayload {
  status?: number;
  message: string;
}

export const fetchCompanyRisks = createRoutine<
  SimplePayloadCreator,
  SimplePayloadCreator<{ companyId: string }>,
  SimplePayloadCreator<FetchCompanyRisksSuccessPayload>, // success
  SimplePayloadCreator<FetchCompanyRisksFailurePayload>,
  SimplePayloadCreator
>('@company/fetchRisks', {});
